import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-songs-simmer',
  templateUrl: './songs-simmer.component.html',
  styleUrls: ['./songs-simmer.component.css']
})
export class SongsSimmerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
